import { render } from "./DeleteConfirmation.vue?vue&type=template&id=1c5928fc"
import script from "./DeleteConfirmation.vue?vue&type=script&lang=js"
export * from "./DeleteConfirmation.vue?vue&type=script&lang=js"
script.render = render

export default script